import { render, staticRenderFns } from "./noticeAnnouncement.vue?vue&type=template&id=565b2442"
import script from "./noticeAnnouncement.vue?vue&type=script&lang=js"
export * from "./noticeAnnouncement.vue?vue&type=script&lang=js"
import style0 from "./noticeAnnouncement.vue?vue&type=style&index=0&id=565b2442&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports